import Nav from "@/components/Header/Nav/Nav.tsx";
import Footer from "@/components/Footer/Footer.tsx";
import GridComponent from "@/components/GridComponent/GridComponent";
import ImageContainer from "@/components/ImageContainer/ImageContainer";
import DoubleBlock from "@/components/DoubleBlock/DoubleBlock";
import KariereForm from "@/components/ContactForm/KarriereForm";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CookiePopupButton from "../components/CookieBanner/CookiePopupButton";
import FaqBlock from "@/components/FAQ/FAQBlock";
import { getJobsData } from "@/data/jobs";
import { Helmet } from "react-helmet";

const Karriere = () => {
  const { t } = useTranslation("pages");
  const faqData = getJobsData();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const gridItems = t("karriere.grid.items", { returnObjects: true }) as Array<{
    title: string;
    description?: string;
  }>;

  const gridData = [
    {
      title: gridItems[0].title,
    },
    {
      icon: "/images/Grid/business-growth-ico.svg",
      title: gridItems[1].title,
      description: gridItems[1].description,
    },
    {
      icon: "/images/Grid/growth-ico.svg",
      title: gridItems[2].title,
      description: gridItems[2].description,
    },
    {
      icon: "/images/Grid/coffee-machine-ico.svg",
      title: gridItems[3].title,
      description: gridItems[3].description,
    },
    {
      icon: "/images/Grid/career-path-ico.svg",
      title: gridItems[4].title,
      description: gridItems[4].description,
    },
    {
      icon: "/images/Grid/voice-matching-ico.svg",
      title: gridItems[5].title,
      description: gridItems[5].description,
    },
    {
      icon: "/images/Grid/work-life-balance-ico.svg",
      title: gridItems[6].title,
      description: gridItems[6].description,
    },
    {
      icon: "/images/Grid/multitasking-ico.svg",
      title: gridItems[7].title,
      description: gridItems[7].description,
    },
  ];

  return (
    <div>
      <Helmet>
        <title>{t("karriere.meta.title")}</title>
        <link rel="icon" href="/images/favicon.ico" type="image/x-icon" />
      </Helmet>
      <Nav></Nav>
      <DoubleBlock
        leftTitle={t("karriere.hero.leftTitle")}
        rightText={t("karriere.hero.rightText")}
      ></DoubleBlock>
      <ImageContainer src="/images/karriere-img.webp" alt="Partner" />
      <GridComponent
        items={gridData}
        title={t("karriere.grid.title")}
        bottomTitle={t("karriere.grid.bottomTitle")}
        bottomText={t("karriere.grid.bottomText")}
      ></GridComponent>
      <FaqBlock
        faqData={faqData}
        subtitle={t("karriere.faq.subtitle")}
        variant="job"
      />
      <KariereForm></KariereForm>
      <CookiePopupButton></CookiePopupButton>
      <Footer></Footer>
    </div>
  );
};

export default Karriere;
